import { render, staticRenderFns } from "./messageClinic.vue?vue&type=template&id=279d880f&scoped=true&"
import script from "./messageClinic.vue?vue&type=script&lang=js&"
export * from "./messageClinic.vue?vue&type=script&lang=js&"
import style0 from "./messageClinic.vue?vue&type=style&index=0&id=279d880f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279d880f",
  null
  
)

export default component.exports